package utils

import kotlinx.browser.window

actual fun isMobileDevice(): Boolean {
    val ua = window.navigator.userAgent
    return Regex("Android|iPhone|iPad|iPod|Mobile", RegexOption.IGNORE_CASE).containsMatchIn(ua)
}
